export default "__VITE_ASSET__C_hL6YDf__"